import { Stack, Skeleton, Divider, Box, Group } from '@mantine/core';
import { DAYS_OF_WEEK } from './types';
import { AvailabilityType, AvailabilityTypeEnum } from '@bariendo/lib/scheduling';

export function AvailabilityDrawerSkeleton({ availabilityType }: { availabilityType: AvailabilityType }) {
  return (
    <Stack gap="sm" py="sm">
      {/* Availability Type Skeleton */}
      <Skeleton height={36} radius="sm" />

      {/* Provider Skeleton */}
      <Skeleton height={36} radius="sm" />

      {/* Visit Type Skeleton */}
      <Skeleton height={36} radius="sm" />

      {/* Timezone Skeleton */}
      <Skeleton height={36} radius="sm" />

      <Divider />

      {availabilityType === AvailabilityTypeEnum.WEEKLY && (
        <Box>
          <Skeleton height={20} width={60} radius="sm" mb="md" />
          <Stack gap="md">
            {DAYS_OF_WEEK.map((day) => (
              <Box key={day.value}>
                <Group gap="md" align="flex-start" wrap="nowrap">
                  <Skeleton height={20} width={100} radius="sm" />
                  <Stack gap="sm" style={{ flex: 1, minWidth: 0 }}>
                    <Skeleton height={60} radius="sm" />
                    <Skeleton height={40} radius="sm" />
                  </Stack>
                </Group>
              </Box>
            ))}
          </Stack>
        </Box>
      )}

      {availabilityType === 'onetime' && (
        <Box>
          <Skeleton height={36} radius="sm" />
          <Skeleton height={36} radius="sm" />
          <Skeleton height={36} radius="sm" />
        </Box>
      )}
    </Stack>
  );
}
